import { atom } from 'jotai'
import { atomEffect } from 'jotai-effect'
import { eventNavigate$ } from '~/navigation/atoms'
import { reservationInputStateValue$, reservationResult$ } from './stateMachine/context'

reservationResult$.debugLabel = 'reservationResult$'

const succeed$ = atom((get) => {
  const state = get(reservationInputStateValue$)
  return state === 'RESERVE_SUCCESS'
})

export const listenReserveSuccess$ = atomEffect((get, set) => {
  if (get(succeed$)) {
    set(eventNavigate$, { type: 'reserveSucceed' })
  }
})
